export default __webpack_public_path__ + "static/Digital-HP-Branded-Tearsheet-379443198604d47de2a4f866c152346e.jpg";